import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadContent, contentLoaded, showLoader, hideLoader } from './actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ loadContent, contentLoaded, showLoader, hideLoader }, dispatch)
}

export default (InnerComponent) => {
    @connect(null, mapDispatchToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
